/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import { SidebarMenuItem } from './SidebarMenuItem'
import { toAbsoluteUrl } from '../../../../helpers';
import { useTranslation } from 'react-i18next';
import fetchAPI from '../../../../../common/fetchAPI';
import { useFormik } from 'formik';
import i18n from '../../../../../i18n/config';
import {
  checkedshowAdminPagesState, UncheckedshowAdminPagesState, updatePageIdState, getEmployeeProfileSettingAsync,
  getAccountAdminOptionPages, getGlobalAccountPreferenceDataAsync, getCustomPagePermissionsAsync,
  getAccountFeatureAsync,
  UpdateCurrentPopupId
} from '../../../../../common/GlobalSlice'
import { t } from 'i18next';
import { useLocation } from 'react-router-dom';
import { getValueFromResource } from '../../../../../common/timeLiveFunction';
import { updateFeature } from '../../../../../features/admin/featureManagement/featureManagementSlice';

const initialValuesForPermissions = {
  IsEmployee: false, //4 
  IsClient: false, //8
  IsProject: false, //31
  IsDashboard: false, // 25
  IsMyProjects: false,// 27
  IsMyTasks: false,// 28
  IsMyTimesheet: false,// 18 
  IsTimeEntryPeriodView: false,// 19
  IsMyAttendance: false,// 186
  IsMyExpenses: false,// 135 
  IsMyTimeOff: false,// 142
  IsMyReports: false,// 124
  IsMyApprovals: false,// 159
  IsBilling: false, //134
  IsTaskRequestApproval: false,//201
  IsTimeOffApproval: false,//144,
  IsExpenseApproval: false,//36
  IsTimeSheetApproval: false,//38
  IsCalendar:false, //508
  IsSchedule: false, //509
  permissionList: []
}

const SidebarMenuMain = (props: any) => {
  const intl = useIntl();
  const { showAdminPages, pageId, menuList, manageTerminologyList, accountFeatureList, masterAccountRoleId } = useAppSelector((state) => state.globalState);
  const { i18n } = useTranslation();
  const [menuItems, setMenuItems] = useState<any>([]);
  const dispatch = useAppDispatch();
  const [childs, setChilds] = useState(initialValuesForPermissions);
  const location = useLocation()
  const routeName = location.pathname.split('/').filter(Boolean)[0];
  const foundItem = menuList.filter(item => item.SystemCategoryPageFrontEnd != null && item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase())[0];
  const { isUpdateData } = useAppSelector((state) => state.featureManagement);
  const showCalendar = accountFeatureList?.some((item: any) => item?.Id === '9289f75c-48be-4002-bef6-df8be6e014cb') ?? false;
  const showScheduler = accountFeatureList?.some((item: any)=> item?.Id === '444fed58-16e0-49a4-8e42-b0e01c5e569b') ??  false;
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const expireFalg = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");
  const GetAccountAdminOptionPages = async () => {
    dispatch(getAccountAdminOptionPages());
  }
  useLayoutEffect(() => {
    dispatch(getCustomPagePermissionsAsync("8,31,4,25,27,28,18,19,186,135,142,124,159,134,201,36,38,144,508, 509")).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        let permissions = res.payload;
        setChilds({
          ...childs,
          IsEmployee: getPermission(4, permissions),
          IsClient: getPermission(8, permissions),
          IsProject: getPermission(31, permissions),
          IsDashboard: getPermission(25, permissions),
          IsMyProjects: getPermission(27, permissions),
          IsMyTasks: getPermission(28, permissions),
          IsMyTimesheet: getPermission(18, permissions),
          IsTimeEntryPeriodView: getPermission(19, permissions),
          IsMyAttendance: getPermission(186, permissions),
          IsMyExpenses: getPermission(135, permissions),
          IsMyTimeOff: getPermission(142, permissions),
          IsMyReports: getPermission(124, permissions),
          IsMyApprovals: getPermission(38, permissions) || getPermission(36, permissions) || getPermission(144, permissions) || getPermission(201, permissions),
          IsBilling: getPermission(134, permissions),
          IsTaskRequestApproval: getPermission(201, permissions),
          IsTimeOffApproval: getPermission(144, permissions),
          IsExpenseApproval: getPermission(36, permissions),
          IsTimeSheetApproval: getPermission(38, permissions),
          IsCalendar: getPermission(508, permissions),
          IsSchedule: getPermission(509, permissions),
        });
      }
    })
    dispatch(updateFeature(false))
  }, [isUpdateData]);

  useEffect(() => {
    dispatch(getAccountFeatureAsync()).then((res: any) => { })
  }, [isUpdateData]);

  function getPermission(id: any, permissions: any) {
    const permission = permissions.find((x: any) => x.Id === id);
    return permission ? permission.IsList : false; // Default to false if permission is not found
  }

  useEffect(() => {
    GetAccountAdminOptionPages();
  }, [accountFeatureList])

  const removePages = (id: any) => {
    const numbers: number[] = [1, 95, 8, 175, 4, 174, 188, 148, 171, 173, 31, 191, 105, 195, 169, 154, 250, 190,516, 518, 150]; //SystemSecurityCategoryPageId:190 is for WebhooksSenderLog page which is showing in admin options


    const filteredNumbers = numbers.filter((num) => num == id);
    return filteredNumbers.length > 0 ? true : false
  }

  useEffect(() => {
    const groupedMenuItems: any = {};
    menuList.forEach((item: any, index: any) => {
      if (!removePages(item.SystemSecurityCategoryPageId)) {
        // if (item.SystemSecurityCategoryId === 1 && item.Folder === 'AccountAdmin') {          
        if (item.SystemSecurityCategoryId === 1) {
          if (!groupedMenuItems[item.SystemSecurityCategoryPageSectionId]) {
            groupedMenuItems[item.SystemSecurityCategoryPageSectionId] = [];
          }
          //feature management work
          //if (accountFeatureList.length > 0 && accountFeatureList.some(feature => feature.Id === item.SystemFeatureId)) {
          if (item.SystemFeatureId === null || accountFeatureList.some(feature => feature.Id === item.SystemFeatureId)) {
            groupedMenuItems[item.SystemSecurityCategoryPageSectionId].push(item);
          }
        }
      }
    });
    setMenuItems(groupedMenuItems);
  }, [menuList])

  const renderSidebarMenuItem = (featureName: string, icon: string, path: string, defaultTitle: string, pageId: string, fontIcon: string = "") => {
    let transformedValue: string = defaultTitle;
    if (manageTerminologyList && manageTerminologyList.length > 0) {
      manageTerminologyList.map((manageTerminologyItem: any, index: any) => {
        let isManageTerminologyExsist: boolean = false;
        isManageTerminologyExsist = defaultTitle.includes(manageTerminologyItem.TerminologyName)
        if (isManageTerminologyExsist) {
          transformedValue = defaultTitle.replace(defaultTitle, manageTerminologyItem.UserDefinedName)
          return true;
        }
        return false;
      })
    }
    if (featureName !== "") {
      if (accountFeatureList.length > 0 && accountFeatureList.filter(x => x.Name === featureName).length > 0 &&
        accountFeatureList.filter(x => x.Name === featureName)[0].Name == featureName) {
        // return <SidebarMenuItem icon={icon} to={path} title={transformedValue} />

        return <SidebarMenuItem icon={icon} to={expireFalg ? '/expiry' : path} pageId={pageId} title={transformedValue} onClick={() => handleClick(pageId)} />
      }
    }
    else {
      return <SidebarMenuItem icon={icon} to={expireFalg ? '/expiry' : path} pageId={pageId} title={transformedValue} onClick={() => handleClick(pageId)} />
    }
    return null;
  };

  const handleClick = (securityCategoryId: any) => {
    dispatch(updatePageIdState(securityCategoryId));
    dispatch(UpdateCurrentPopupId(null));
  };
  
  return (
    <>
      {(showAdminPages || (routeName === 'manageterminology' && foundItem != undefined)) ? (
        <>
          <div className='menu-item' style={{ marginTop: '-10px' }}>
            <div className='menu-content pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{getValueFromResource('SETTINGS', dispatch, t)}</span>
            </div>
          </div>
          <div>
            {Object.keys(menuItems).map((sectionId) => (
              menuItems[sectionId].length > 0 && (  // Use '&&' for conditional rendering                 
                <div key={sectionId}>
                  <SidebarMenuItemWithSub
                    icon={menuItems[sectionId][0].SystemSecurityCategoryPageSectionIcon}
                    key={sectionId}
                    to={sectionId}
                    // title={menuItems?.[sectionId]?.[0]?.SystemSecurityCategoryPageSectionName || 'Default Title'}
                    title={getValueFromResource(menuItems?.[sectionId]?.[0]?.SystemSecurityCategoryPageSectionName || 'Default Title', dispatch, t)}
                    fontIcon={''}
                  >
                    {menuItems[sectionId].map((menuItem: any, index: any) => {
                      const handleAdminMenuClick = (securityCategoryId: any) => {
                        dispatch(updatePageIdState(securityCategoryId));
                        if (foundItem != undefined) {
                          dispatch(checkedshowAdminPagesState());
                        }
                      };
                      let defaultValue = getValueFromResource(menuItem.SystemCategoryPageDescription, dispatch, t)
                      let transformedValue: string = menuItem.SystemCategoryPageDescription
                      if (manageTerminologyList && manageTerminologyList.length > 0) {
                        manageTerminologyList.map((manageTerminologyItem: any, index: any) => {
                          let isManageTerminologyExsist: boolean = false;
                          isManageTerminologyExsist = defaultValue.includes(manageTerminologyItem.TerminologyName)
                          if (isManageTerminologyExsist) {
                            transformedValue = defaultValue.replace(defaultValue, manageTerminologyItem.UserDefinedName)
                            return true;
                          }
                          return false;
                        })
                      }
                      return (
                        <SidebarMenuItem
                          key={menuItem.SystemSecurityCategoryPageId}
                          icon={''}
                          onClick={() => handleAdminMenuClick(menuItem.SystemSecurityCategoryPageId)}
                          to={expireFalg ? '/expiry' : `/${menuItem.SystemCategoryPageFrontEnd}`}
                          title={transformedValue}
                          hasBullet={true}
                        />
                      );
                    })}
                  </SidebarMenuItemWithSub>
                </div>
              )
            ))}
          </div>
        </>
      ) :
        (
          <>
            {accountFeatureList.length > 0 &&
              (childs.IsMyTimesheet || childs.IsTimeEntryPeriodView || childs.IsMyExpenses || childs.IsMyTimeOff || childs.IsMyAttendance) &&
              <div className='menu-item'>
                <div className='menu-content pt-1 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-7'>{getValueFromResource('TRACK', dispatch, t)}</span>
                </div>
              </div>
            }
            {(childs.IsMyTimesheet || childs.IsTimeEntryPeriodView) && renderSidebarMenuItem('TimesheetManagement', 'time', '/timesheet', getValueFromResource('Timesheet', dispatch, t), '18')}
            {(childs.IsCalendar && showCalendar) && renderSidebarMenuItem('Calendar', 'calendar', '/calendar', getValueFromResource('Calendar', dispatch, t), '508')}
            {(childs.IsSchedule && showScheduler) && renderSidebarMenuItem('Schedule', 'abstract-45', '/schedule', getValueFromResource('Schedule', dispatch, t), '509')}
            {childs.IsMyExpenses && renderSidebarMenuItem('ExpenseManagement', 'dollar', '/expense', getValueFromResource('Expense', dispatch, t), '135')}
            {childs.IsMyTimeOff && renderSidebarMenuItem('TimeOff', 'calendar', '/timeoffrequest', getValueFromResource('Time Off', dispatch, t), '142')}
            {childs.IsMyAttendance && renderSidebarMenuItem('Attendance', 'calendar-tick', '/attendance', getValueFromResource('Attendance', dispatch, t), '186')}
            {(childs.IsEmployee || childs.IsClient || childs.IsProject || childs.IsMyTasks || childs.IsBilling || childs.IsMyApprovals) &&
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-4 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-7'>{getValueFromResource('MANAGE', dispatch, t)}</span>
                  </div>
                </div>
                {/* {masterAccountRoleId  && */}
                <>
                  {childs.IsEmployee && renderSidebarMenuItem('', 'people', '/employee', getValueFromResource('Employees', dispatch, t), '4')}
                  {childs.IsClient && renderSidebarMenuItem('', 'profile-user', '/client', getValueFromResource('Clients', dispatch, t), '8')}
                  {/* {childs.IsBilling && renderSidebarMenuItem('Billing', 'bill', '/billing', 'Billing', '134')} */}
                </>
                {/* } */}
                {(childs.IsProject || childs.IsMyProjects) && renderSidebarMenuItem('', 'add-folder', '/projects', getValueFromResource('Projects', dispatch, t), '31')}
                {childs.IsMyTasks && renderSidebarMenuItem('', 'add-files', '/mytasks', getValueFromResource('Tasks', dispatch, t), '28')}
                {/* {masterAccountRoleId == 1 && */}
                {childs.IsBilling &&
                  <SidebarMenuItemWithSub
                    icon={'bill'}
                    to={expireFalg ? '/expiry' : '/billing'}
                    title={getValueFromResource('Billing', dispatch, t)}
                  >
                    {/* {childs.IsTimeSheetApproval && renderSidebarMenuItem('', 'questionnaire-tablet', '/accounttimeexpensebilling', t('Invoice Management'), '129')}
                    {childs.IsExpenseApproval && renderSidebarMenuItem('', 'time', '/timebillingworksheet', t('Time Billing Worksheet'), '130')}
                    {childs.IsTimeOffApproval && renderSidebarMenuItem('', 'dollar', '/expensebillingworksheet', t('Expense Billing Worksheet'), '131')} */}
                    {childs.IsBilling && renderSidebarMenuItem('', 'questionnaire-tablet', '/accounttimeexpensebilling', getValueFromResource('Invoice Management', dispatch, t), '129')}
                    {(childs.IsMyTimesheet || childs.IsTimeEntryPeriodView) && renderSidebarMenuItem('', 'time', '/timebillingworksheet', getValueFromResource('Time Billing Worksheet', dispatch, t), '130')}
                    {childs.IsMyExpenses && renderSidebarMenuItem('', 'dollar', '/expensebillingworksheet', getValueFromResource('Expense Billing Worksheet', dispatch, t), '131')}
                  </SidebarMenuItemWithSub>
                }
                {childs.IsMyApprovals && (
                  <SidebarMenuItemWithSub
                    icon={'menu'}
                    to={expireFalg ? '/expiry' : '/approvals'}
                    title={getValueFromResource('Approvals', dispatch, t)}
                  >

                    {childs.IsTimeSheetApproval && renderSidebarMenuItem('', 'time', '/timesheetapproval', getValueFromResource('Timesheet Approval', dispatch, t), '38')}
                    {childs.IsExpenseApproval && renderSidebarMenuItem('', 'dollar', '/expenseapproval', getValueFromResource('Expense Approval', dispatch, t), '36')}
                    {childs.IsTimeOffApproval && renderSidebarMenuItem('', 'calendar', '/timeoffapproval', getValueFromResource('Time Off Approval', dispatch, t), '144')}
                    {childs.IsTaskRequestApproval && renderSidebarMenuItem('', 'menu', '/taskrequesthoursapproval', getValueFromResource('Task Request Approval', dispatch, t), '201')}
                  </SidebarMenuItemWithSub>
                )}
              </>
            }
            <div className='menu-item'>
              <div className='menu-content pt-4 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-7'>{getValueFromResource('ANALYZE', dispatch, t)}</span>
              </div>
            </div>
            {childs.IsDashboard && renderSidebarMenuItem('', 'home-3', '/dashboard', getValueFromResource('Dashboard', dispatch, t), '25', 'bi-app-indicator')}
            {/* {childs.IsDashboard && renderSidebarMenuItem('', 'home-3', '/dashboard', getValueFromResource('Dashboard', dispatch, t), 'bi-app-indicator')} */}
            {/* {childs.IsDashboard && renderSidebarMenuItem('', 'home-3', '/dashboard', intl.formatMessage({ id: getValueFromResource('MENU.DASHBOARD', dispatch,t) }), 'bi-app-indicator')} */}
            {/* {childs.IsDashboard && renderSidebarMenuItem('', 'home-3', '/dashboard', 'Dashboard', '25')} */}
            {childs.IsMyReports && renderSidebarMenuItem('', 'chart-simple-2', '/myreports', getValueFromResource('Reports', dispatch, t), '124')}
          </>
        )
      }
    </>
  )
}

export { SidebarMenuMain }